export const save = (state, settings) => {
  state.cancellationPolicy = settings.cancellationPolicy;
  state.termsAndConditions = settings.termsAndConditions;
  state.paymentInfo = settings.paymentInfo;
  state.pickupInfo = settings.pickupInfo;
  state.refundInfo = settings.refundInfo;
};
